import { Trans } from 'react-i18next';

import { createTranslatedText, Translate } from '@dreryk/react-common';
import {
   ContentNode,
   Link,
   LinkVariant,
   Modal,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
   StyledFlex,
   Text,
} from '@dreryk/react-components';

import { healthcareInstitutionCommonKeys } from '../../../translations';

type PurchasePackageModalProps = {
   readonly onClose: VoidFunction;
   readonly title: ContentNode;
};

const COMPANY_DATA = {
   hotlineNumber: '+48 12 380 08 84',
   email: 'wsparcieegabinet@dreryk.pl',
};

export const PurchasePackageModal = (props: PurchasePackageModalProps): JSX.Element => {
   return (
      <Modal testId={'purchasePackageModal'} title={props.title} width={ModalWidth.NORMAL}>
         <StyledFlex direction='column' gap={8}>
            <Text testId={'content'}>
               <Translate>{healthcareInstitutionCommonKeys.purchasePackageModal.content}</Translate>
            </Text>
            <Text testId={'phoneNumber'}>
               <Trans
                  i18nKey={healthcareInstitutionCommonKeys.purchasePackageModal.hotlineLabel}
                  components={{
                     link: (
                        <Link
                           testId={'phoneNumberLink'}
                           href={`tel:${COMPANY_DATA.hotlineNumber}`}
                           active={false}
                           block={false}
                           variant={LinkVariant.PRIMARY}
                           label={createTranslatedText(COMPANY_DATA.hotlineNumber)}
                        />
                     ),
                  }}
               />
            </Text>
            <Text testId={'emailAddress'}>
               <Trans
                  i18nKey={healthcareInstitutionCommonKeys.purchasePackageModal.emailLabel}
                  components={{
                     link: (
                        <Link
                           testId={'emailAddressLink'}
                           href={`mailto:${COMPANY_DATA.email}`}
                           active={false}
                           block={false}
                           variant={LinkVariant.PRIMARY}
                           label={createTranslatedText(COMPANY_DATA.email)}
                        />
                     ),
                  }}
               />
            </Text>
         </StyledFlex>
         <ModalCloseButton onClick={props.onClose} />
         <ModalConfirmButton
            label={healthcareInstitutionCommonKeys.purchasePackageModal.close}
            onClick={props.onClose}
         />
      </Modal>
   );
};
